<div class="container-fluid main-card">
    <div class="row hide-mobile">
        <div class="col-sm-8 col-11">
            <h1>
                {{ (this.currentSearch && params.id != 'result' ? 'Votre secteur ' + this.currentSearch.title : 'Secteur de recherche') }}
                <span>Trouvez les meilleures villes où investir</span>
            </h1>
        </div>
        <div class="col-sm-4 col-1">
            <p class="btn btn-outline btn-tool float-right  mobile-icon mt-4" (click)="openTuto()">
                <img src="assets/icons/yt.png"  class="n-size"alt=""/><span>Tutoriel : Mes secteurs</span>
            </p>
        </div>
    </div>
    <div class="row favorite-toolbar mb-4 mt-3 mt-md-0">
        <div class="col-lg-4 col-8 pe-0 favorite-select">
            <!-- Sélecteur de secteur (chip -> popup, comme le sélecteur de liste des favoris) -->
            <button #searchListBtn class="btn btn-list-selector" [matMenuTriggerFor]="searchListMenu"
                    #searchListTrigger="matMenuTrigger" (click)="searchListText = ''"
                    [stepContent]="filtersCityListSaveStepContent"
                    [joyrideStep]="'filtersCityListSaveStep'"
                    [disabled]="userSearchs.length == 0 || !authenticationService.isAllowed('essentiel')">
                {{ currentSearch && params.id != 'result' ? currentSearch.title : 'Nouveau secteur' }}
                <i class="fa fa-chevron-down"></i>
            </button>
            <mat-menu #searchListMenu="matMenu" class="list-selector-menu mobile-sheet" backdropClass="mobile-sheet-backdrop">
                <div class="list-menu-content" [style.min-width.px]="searchListBtn.offsetWidth"
                     (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                    <div class="list-menu-search">
                        <i class="fa fa-search"></i>
                        <input type="text" placeholder="Rechercher..." [(ngModel)]="searchListText">
                    </div>
                    <div class="list-menu-items">
                        <a *ngFor="let s of filteredUserSearchs"
                           class="list-menu-item"
                           [class.active]="currentSearch && '' + s.id === '' + currentSearch.id"
                           (click)="currentSearch = s; trackingService.click('search_city_result_select_search', s.id); loadSearch(s); searchListTrigger.closeMenu()">
                            {{ s.title }}
                        </a>
                    </div>
                    <div class="list-menu-footer">
                        <button class="btn btn-outline w-100" type="button"
                                (click)="searchListTrigger.closeMenu(); newSearch()">
                            + Nouveau secteur
                        </button>
                    </div>
                </div>
            </mat-menu>
        </div>

        <!-- Actions MOBILE : Éditer (mat-menu -> popup + backdrop, comme la recherche)
             (la sauvegarde d'un secteur non enregistré passe par le bouton flottant) -->
        <div class="favorite-actions ps-2 visible-mobile">
            <button class="btn btn-outline mobile-icon"
                    (click)="trackingService.click('search_city_result_search_edit', currentSearch?.id)"
                    [matMenuTriggerFor]="editMobileMenu">
                <i class="fa fa-ellipsis-v"></i>
                <span>Éditer</span>
            </button>
            <mat-menu #editMobileMenu="matMenu" class="mobile-sheet edit-sheet-menu" backdropClass="mobile-sheet-backdrop">
                <button mat-menu-item (click)="openTuto()">
                    <img src="assets/icons/yt.png" class="n-size" alt=""/>
                    <span>Tutoriel : Mes secteurs</span>
                </button>
                <button mat-menu-item *ngIf="currentSearch && params.id == 'result'"
                        (click)="trackingService.click('search_city_result_search_save', currentSearch.id);saveSearch()">
                    <i class="fa cfa cfa-save"></i>
                    <span>Sauvegarder mon secteur</span>
                </button>
                <button mat-menu-item *ngIf="currentSearch && params.id != 'result'"
                        (click)="trackingService.click('search_city_result_search_rename', currentSearch.id);editSearch()">
                    <i class="fa cfa cfa-pencil"></i>
                    <span>Renommer</span>
                </button>
                <button mat-menu-item *ngIf="currentSearch && params.id != 'result'"
                        (click)="trackingService.click('search_city_result_search_duplicate', currentSearch.id);duplicateSearch()">
                    <i class="fa cfa cfa-clone"></i>
                    <span>Dupliquer</span>
                </button>
                <button mat-menu-item class="text-danger" *ngIf="currentSearch && params.id != 'result'"
                        (click)="trackingService.click('search_city_result_search_delete', currentSearch.id);deleteSearch()">
                    <i class="fa cfa cfa-trash"></i>
                    <span>Supprimer</span>
                </button>
            </mat-menu>
        </div>

        <div class="col-lg-2 col-3 ps-2 dropdown dropstart hide-mobile">
            <button
                *ngIf="currentSearch && params.id != 'result'"
                (click)="trackingService.click('search_city_result_search_edit', currentSearch.id)"
                class="btn btn-outline mobile-icon" id="dropdownEdit" data-bs-toggle="dropdown" aria-haspopup="true"
                aria-expanded="false">
                <i class="fa fa-ellipsis-v"></i>
                <span>Éditer</span>
            </button>
            <div id="editDropdown" class="dropdown-menu dropdown-menu-left" aria-labelledby="dropdownEdit"
                 aria-haspopup="true"
                 aria-expanded="false">
                <ul class="pictoList">
                    <li>
                        <a (click)="trackingService.click('search_city_result_search_rename', currentSearch.id);editSearch()">
                            <i class="fa cfa cfa-pencil"></i>
                            Renommer
                        </a>
                    </li>
                    <li>
                        <a (click)="trackingService.click('search_city_result_search_duplicate', currentSearch.id);duplicateSearch()">
                            <i class="fa cfa cfa-clone"></i>
                            Dupliquer
                        </a>
                    </li>
                    <li class="delete">
                        <a (click)="trackingService.click('search_city_result_search_delete', currentSearch.id);deleteSearch()">
                            <i class="fa cfa cfa-trash"></i>
                            Supprimer
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="col-lg-6 col-md-12 col-4 text-end ps-0 hide-mobile">
            <div class="d-inline-block">
                <button class="btn btn-outline mobile-icon"
                        (click)="trackingService.click('search_city_result_search_save', currentSearch.id);saveSearch()"
                        *ngIf="this.currentSearch && params.id == 'result'"
                        (next)="saveSearch()"
                        [stepContent]="filtersCityResultSaveStepContent"
                        [joyrideStep]="'filtersCityResultSaveStep'"
                        stepPosition="bottom">
                    <i class="fa cfa cfa-save"></i>
                    <span>Sauvegarder mon secteur</span>
                </button>
            </div>
            <a class="btn btn-primary btn-filter-toggle ms-2 ps-sm-4 pe-sm-4 mobile-icon"
               (click)="filtersDrawer ? filtersDrawer = false : openFiltersDrawer()"
               [stepContent]="searchCityFiltersStepContent"
               [joyrideStep]="'searchCityFiltersStep'"
               stepPosition="bottom">
                <i class="fa" [ngClass]="filtersDrawer ? 'fa-close' : 'cfa cfa-filter'"></i>
                <span>Filtrer</span>
                <span class="filter-badge" *ngIf="getActiveFilterCount() > 0">{{ getActiveFilterCount() }}</span>
            </a>
        </div>
    </div>
    <div class="row mt-md-3 mb-3 resultRow favorite-subheader">
        <div class="col-md-6 col-12">
            <!-- h2 toujours rendu (vide pendant le chargement) : la ligne réserve sa place, pas de décalage -->
            <h2>
                <ng-container *ngIf="result >= 0">
                    <b class="text-primary">{{ result | number }}&nbsp;</b>
                    <ng-container *ngIf="result <= 1">ville</ng-container>
                    <ng-container *ngIf="result > 1">villes</ng-container>
                </ng-container>
            </h2>
        </div>
        <div class="col-md-3 offset-md-3 col-12 ps-md-0 sort-filter-group">
            <!-- MOBILE : Filtrer + Tri (chip -> popup, comme les recherches) -->
            <a class="btn btn-primary sort-filter-btn visible-mobile"
               [routerLink]="['/app/city', params.id, 'filters']">
                <i class="fa cfa cfa-filter"></i>
                <span>Filtrer</span>
                <span class="filter-badge" *ngIf="getActiveFilterCount() > 0">{{ getActiveFilterCount() }}</span>
            </a>
            <button class="btn btn-outline sort-chip visible-mobile" [matMenuTriggerFor]="sortMenu">
                <span class="sort-chip-label">Tri : {{ getSortLabel() }}</span>
                <i class="fa fa-chevron-down ms-2"></i>
            </button>

            <!-- DESKTOP : select, comme les recherches -->
            <mat-form-field class="no-label hide-mobile">
                <mat-label>Tri :</mat-label>
                <mat-select disableOptionCentering [(ngModel)]="sort"
                            (ngModelChange)="trackingService.click('search_city_sort', sort);setSort();"
                            placeholder="Trier par">
                    <mat-option *ngFor="let opt of sortOptions" [value]="opt.value">Tri : {{ opt.label }}</mat-option>
                </mat-select>
            </mat-form-field>

            <!-- Popup Tri -->
            <mat-menu #sortMenu="matMenu" class="mobile-sheet" backdropClass="mobile-sheet-backdrop">
                <button mat-menu-item *ngFor="let opt of sortOptions"
                        (click)="sort = opt.value; trackingService.click('search_city_sort', sort); setSort()">
                    <i class="fa fa-check me-2" [style.visibility]="sort === opt.value ? 'visible' : 'hidden'"></i>
                    <span>{{ opt.label }}</span>
                </button>
            </mat-menu>
        </div>
    </div>
    <div class="row">
        <ng-container *ngFor="let city of cities; index as i;">
            <div class="col-12 mb-4">
                <div class="card searchResult"
                     [stepContent]="searchCityResultStepContent"
                     [joyrideStep]="'searchCityResultStep' + i">
                    <div class="card-body card-{{ city.id }}" *ngIf="city">
                        <div class="container-fluid">
                            <div class="mainRow row">

                                <div class="wrapImg me-2 mb-lg-0 mb-2"
                                     [stepContent]="searchCityResultImgStepContent"
                                     [joyrideStep]="'searchCityResulImgtStep' + i">
                                    <img src="{{ city.image }}" alt=""/>
                                </div>
                                <div class="mainInfo me-lg-2 mb-lg-0 mb-2">
                                    <b class="text-primary fs-4 d-block" style="line-height: 1.5rem;">
                                        {{ city.zip_code }}
                                    </b>
                                    <span class="fs-7">
                                            {{ city.name }}
                                        </span>
                                    <div class="mt-0 mt-sm-2">
                                        <a class="btn btn-primary btn-sm text-white city-analyse-btn"
                                           [routerLink]="['/app/tools/ville', city.city_code]" target="_blank">
                                            Analyse de la ville
                                        </a>
                                    </div>
                                </div>
                                <div class="kpiInfo kpiInfoVille pe-0 ps-3 col-xxl-6 col-xl-6 col-lg-5">
                                    <div class="row">
                                        <div class="col-12 dataInfo">
                                            <div class="row pt-3 pt-sm-0">
                                                <div class="kpi-value">
                                                    <label>Nombre d'habitants</label>
                                                    <p *ngIf="city.demographie_annuelle && city.demographie_annuelle[EVOL_DEMO_LAST_YEAR] != null; else noValueTpl"
                                                       [ngClass]="{'value': true, 'text-green' : city.demographie_annuelle.Cr == 1, 'text-red' : city.demographie_annuelle.Cr == -1}">
                                                        {{ city.demographie_annuelle[EVOL_DEMO_LAST_YEAR] | number: '1.0-0' }}
                                                        <i *ngIf="city.demographie_annuelle.Cr == 1"
                                                           matTooltipClass="tooltip-button"
                                                           matTooltip="Démographie en hausse"
                                                           class="fa fa-arrow-up"></i>
                                                        <i *ngIf="city.demographie_annuelle.Cr == 0"
                                                           matTooltipClass="tooltip-button"
                                                           matTooltip="Démographie stable"
                                                           class="fa fa-arrow-right"></i>
                                                        <i *ngIf="city.demographie_annuelle.Cr == -1"
                                                           matTooltipClass="tooltip-button"
                                                           matTooltip="Démographie en baisse"
                                                           class="fa fa-arrow-down"></i>
                                                    </p>
                                                </div>
                                                <div class="kpi-value">
                                                    <label>Niveau de vie moyen/hab</label>
                                                    <p *ngIf="city.carac_commune?.MED_NV != null; else noValueTpl" class="value">
                                                        {{ city.carac_commune.MED_NV | number: '1.0-0' }} <span
                                                        class="unit">€</span>
                                                    </p>
                                                </div>
                                                <div class="kpi-value">
                                                    <label>
                                                        <i class="fa fa-question-circle"
                                                           matTooltipClass="tooltip-button"
                                                           matTooltip="Rendement moyen {{ (city.renta?.r_type == 'M' ?  'pour les maisons uniquement' : city.renta?.r_type == 'A' ? 'pour les appartements uniquement' : 'tous types de  biens confondus') }}, sans prise en compte de travaux"></i>
                                                        Rendement moyen
                                                    </label>
                                                    <p *ngIf="city.renta?.r != null; else noValueTpl" class="value">
                                                        {{ city.renta["r"] * 100| number: '1.0-1' }}
                                                        <span class="unit">%</span>
                                                    </p>
                                                </div>
                                                <div class="kpi-value">
                                                    <label>Étudiants</label>
                                                    <p *ngIf="city.carac_commune?.T_etud != null; else noValueTpl"
                                                       [ngClass]="{'value': true, 'text-green' : city.carac_commune.T_etud >= 0.12 , 'text-red' : city.carac_commune.T_etud <= 0.08}">
                                                        {{ city.carac_commune.T_etud * 100 | number: '1.1-1' }}
                                                        <span class="unit">%</span>
                                                    </p>
                                                </div>
                                                <div class="kpi-value">
                                                    <label>Chômage</label>
                                                    <p *ngIf="city.carac_commune?.T_chom != null; else noValueTpl"
                                                       [ngClass]="{'value': true, 'text-green' : city.carac_commune.T_chom < 0.075 , 'text-red' : city.carac_commune.T_chom >= 0.13}">
                                                        {{ city.carac_commune.T_chom * 100 | number: '1.1-1' }}
                                                        <span class="unit">%</span>
                                                    </p>
                                                </div>

                                                <div class="kpi-value">
                                                    <label>
                                                        Tension locative
                                                    </label>
                                                    <p *ngIf="city.loc_service_tensiometre?.all?.loc >= 0; else noValueTpl" class="value">
                                                        {{ city.loc_service_tensiometre.all.loc }}
                                                        / 8
                                                    </p>
                                                </div>

                                                <div class="kpi-value">
                                                    <label>
                                                        <i class="fa fa-question-circle"
                                                           matTooltipClass="tooltip-button"
                                                           matTooltip="Pourcentage de locataires dans la ville"></i>
                                                        Taux de locataire
                                                    </label>
                                                    <p *ngIf="city.logement?.T_LOC != null; else noValueTpl" class="value">
                                                        {{ city.logement.T_LOC * 100 | number: '1.1-1' }} %
                                                    </p>
                                                </div>

                                                <div class="kpi-value">
                                                    <label>
                                                        <i class="fa fa-question-circle"
                                                           matTooltipClass="tooltip-button"
                                                           matTooltip="Ancienneté des locataires dans le logement, Moyenne France : 4 ans"></i>
                                                        Ancienneté des locataires
                                                    </label>
                                                    <p *ngIf="city.logement?.anc_loc_ann != null; else noValueTpl"
                                                       [ngClass]="{'value': true, 'text-green' : city.logement.anc_loc_ann > 4.5 , 'text-red' : city.logement.anc_loc_ann < 2.5}">
                                                        {{ city.logement.anc_loc_ann | number: '1.1-1' }} années
                                                    </p>
                                                </div>

                                                <div class="kpi-value">
                                                    <label>
                                                        <i *ngIf="!city.evol_prix_ville?.evol_10y"
                                                           class="fa fa-question-circle"
                                                           matTooltipClass="tooltip-button"
                                                           matTooltip="Les données de la ville ne permettent pas d'indiquer une évolution."></i>
                                                        <i *ngIf="!!city.evol_prix_ville?.evol_10y"
                                                           class="fa fa-question-circle"
                                                           matTooltipClass="tooltip-button"
                                                           matTooltip="Variation des prix appartements dans la ville sur 10 ans"></i>
                                                        Évolution des prix sur 10 ans
                                                    </label>
                                                    <p *ngIf="!!city.evol_prix_ville?.evol_10y; else noValueTpl"
                                                       [ngClass]="{'value': true, 'text-green' : toFloat(city.evol_prix_ville.evol_10y) > 0.05 , 'text-red' : toFloat(city.evol_prix_ville.evol_10y) < 0}">
                                                        {{  toFloat(city.evol_prix_ville.evol_10y) * 100 | number: '1.1-1' }}
                                                        <span class="unit">%</span>
                                                    </p>
                                                </div>

                                                <div class="kpi-value">
                                                    <label>
                                                        <i class="fa fa-question-circle"
                                                           matTooltipClass="tooltip-button"
                                                           matTooltip="Prix moyen pour {{ cityService.getFullLib('city.prix_commune.B', city, '') }}"></i>
                                                        Prix/m²
                                                    </label>
                                                    <p *ngIf="cityService.getPriceValue(city, 'city.prix_commune.B', '').pM; else noValueTpl" class="value">
                                                        {{ cityService.getPriceValue(city, 'city.prix_commune.B', '').pM | number: '1.0-0' }}
                                                        <span
                                                            class="unit">€</span>
                                                    </p>
                                                </div>

                                                <div class="kpi-value">
                                                    <label>
                                                        Nombre d'entreprises
                                                    </label>
                                                    <p *ngIf="city.ets?.ETNTOT21 != null; else noValueTpl" class="value">
                                                        {{ city.ets.ETNTOT21 | number: '1.0-0' }}
                                                    </p>
                                                </div>

                                                <ng-template #noValueTpl>
                                                    <p class="value-empty">-</p>
                                                </ng-template>
                                                <div class="kpi-value">
                                                    <label>
                                                        Nombre de commerces
                                                    </label>
                                                    <p *ngIf="city.commerce?.tot_com != null; else noValueTpl" class="value">
                                                        {{ city.commerce.tot_com | number: '1.0-0' }}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

        <div class="card card-loading" [hidden]="!loading">
            <div class="card-body">
                <mat-spinner color="second"></mat-spinner>
            </div>
        </div>

        <ul class="pagination mb-4" *ngIf="loading == false">
            <li *ngIf="page > 1"><a class="prev" (click)="loadResult(page - 1)"><</a></li>
            <li *ngFor="let p of pages"><a (click)="loadResult(p)" [ngClass]="{'current' : p == page}">{{ p }}</a></li>
            <li *ngIf="page < pages[pages.length-1]"><a class="next" (click)="loadResult(page + 1)">></a></li>
        </ul>
    </div>
    <!-- Secteur non enregistré : bouton flottant Sauvegarder (style leboncoin),
             sticky dans la colonne de contenu (comme la recherche) -->
    <div class="btn-save-search-floating-wrap d-flex justify-content-center align-items-start" [class.d-none]="saveFloatingAtBottom"
             *ngIf="currentSearch && params.id == 'result' && getActiveFilterCount() > 0 && !filtersDrawer && !saveFloatingDismissed && loading == false">
            <div class="btn-save-search-floating-group d-inline-flex align-items-stretch overflow-hidden">
                <button class="btn btn-primary btn-save-search-floating"
                        (click)="trackingService.click('search_city_result_search_save', currentSearch.id);saveSearch()">
                    <i class="fa cfa cfa-save"></i>
                    Sauvegarder mon secteur
                </button>
                <button class="btn btn-primary btn-save-search-dismiss d-inline-flex align-items-center" aria-label="Masquer"
                        (click)="saveFloatingDismissed = true">
                    <i class="fa fa-close"></i>
                </button>
            </div>
        </div>
</div>

<!-- Onboarding -->
<joyrideStep [stepContent]="filtersCityStepContent"
             joyrideStep="filtersCityStep"
             stepPosition="center">
</joyrideStep>
<ng-template #filtersCityStepContent>
    <div class="fs-6 user_onboarding_author">
        <img src="assets/Thomas.png" width="40px" class="me-3  rounded-circle"/><b>Thomas</b> de LyBox<br/>
    </div>
    <img src="assets/villes_rentables.png" class="user_onboarding_visuel"/>
    <div class="p-2 user_onboarding_content">
        <h2>Comment trouver les meilleures villes pour investir ?</h2>
        <p>
            LyBox récolte des <b>milliers de données</b> sur toutes les villes de France.<br/>
            <br/>
            Dans ce module, nous allons apprendre à <b>trouver les meilleures villes pour investir</b> autour de chez
            vous.<br/>
            <br/>
            Le résultat va peut-être vous surprendre !
        </p>
    </div>
</ng-template>

<ng-template #searchCityResultStepContent>
    <div class="user_onboarding_content">
        <h2>Aperçu des villes</h2>
        <p>
            Retrouvez ici tous les <b>chiffres clés de la ville</b> comme :
        </p>
        <ul>
            <li>Le nombre d’habitants</li>
            <li>L’évolution des prix</li>
            <li>Les étudiants, le chômage …</li>
        </ul>
        <p>
            La couleur des bulles vous aide dans votre choix :
        </p>
        <ul>
            <li>En <b>vert</b> : c’est positif (Ex : faible taux de chômage ou fort taux d’étudiant)</li>
            <li>En <b>blanc</b> : c’est dans la moyenne</li>
            <li>En <b>rouge</b> : c’est négatif (moins bon que dans le reste de la France)</li>
        </ul>
    </div>
</ng-template>

<ng-template #searchCityResultImgStepContent>
    <div class="user_onboarding_content">
        <h2>Pour plus de détail</h2>
        <p>
            À tout moment, vous pouvez cliquer sur “Analyse de la ville” pour avoir accès à une <b>étude
            détaillée</b>.<br/>
            <br/>
            Tout ça c’est bien beau, mais comment on fait pour <b>choisir les meilleures villes</b> ?<br/>
            <br/>
            Suivez-moi, c’est par ici 🙂<br/>
        </p>
    </div>
</ng-template>

<ng-template #searchCityFiltersStepContent>
    <div class="user_onboarding_content">
        <h2>Modifier les filtres</h2>
        <p>
            Maintenant, allons choisir ensemble les filtres pour construire votre <b>recherche de ville sur mesure</b> !
        </p>
    </div>
</ng-template>

<joyrideStep [stepContent]="filtersCityResultStepContent"
             joyrideStep="filtersCityResultStep"
             stepPosition="center">
</joyrideStep>
<ng-template #filtersCityResultStepContent>
    <div class="user_onboarding_content">
        <h2>Résultat de votre recherche</h2>
        <p>
            Voici la liste des villes correspondant à votre recherche.<br/>
            <br/>
            Votre prochaine ville préférée se trouve sûrement juste ici 😉<br/>
        </p>
    </div>
</ng-template>

<ng-template #filtersCityResultSaveStepContent>
    <div class="user_onboarding_content">
        <h2>Résultat de votre recherche</h2>
        <p>
            Cliquez ici pour enregistrer votre recherche et y revenir quand vous voulez
        </p>
    </div>
</ng-template>

<ng-template #filtersCityListSaveStepContent>
    <div class="user_onboarding_content">
        <h2>Enregistrer votre recherche</h2>
        <p>
            Vous pouvez accéder à vos recherches enregistrées depuis ce menu déroulant.<br/>
            <br/>
            Vous pourrez modifier les critères ou supprimer votre recherche<br/>
            <br/>
            <b>Astuce</b> : Maintenant que votre secteur de recherche est enregistré, vous pouvez l’utiliser dans vos
            recherches d’annonces immobilières !<br/>
            <br/>
            Pour cela, rendez-vous dans le menu “Recherche” à gauche, puis “Secteur de recherche”, puis “Secteur de
            recherche avancé” 😀
        </p>
    </div>
</ng-template>

<!-- Bandeau de filtres (desktop) : mêmes filtres que le mobile, résultats mis à jour en direct -->
<ng-container *ngIf="filtersDrawer">
    <div class="filters-drawer-backdrop hide-mobile" (click)="filtersDrawer = false"></div>
    <div class="filters-drawer hide-mobile">
        <!-- Barre du haut : flèche de retour + nom de la section ouverte (modèle liste -> détail) -->
        <div class="filters-drawer-header">
            <div class="d-flex align-items-center">
                <a class="filters-section-back" *ngIf="filtersCmp.mode == 'filtres'"
                   (click)="filtersCmp.mode = 'sidebar'" aria-label="Retour aux filtres">
                    <i class="fa fa-angle-left"></i>
                </a>
                <h3>{{ filtersCmp.mode == 'filtres' ? filtersCmp.getTabLabel() : 'Filtres' }}</h3>
            </div>
            <i class="fa fa-close cursor-pointer" (click)="filtersDrawer = false"></i>
        </div>
        <app-filters-city #filtersCmp [drawer]="true" [drawerSearchId]="params.id"
                          (paramsChange)="onDrawerParams($event)"
                          (drawerClose)="filtersDrawer = false"></app-filters-city>
    </div>
</ng-container>
